// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import HelpOutlineSvg from '../icons/status/HelpOutline';
var HelpOutline = createSvgIcon({
    as: HelpOutlineSvg,
    ariaLabel: 'help outline',
    category: 'status',
    displayName: 'HelpOutline'
});
export default HelpOutline;
